import { BehaviorSubject } from 'rxjs';
import { addError } from './Error';
import { fetchOrderRequestSchemasApi } from '../Api/OrderRequestSchemas/orderRequestSchemasApi';
import { OrderRequestSchema } from '../types';

const orderRequestSchemasSubject = new BehaviorSubject<OrderRequestSchema[]>([]);
const orderRequestSchemasLoadingSubject = new BehaviorSubject<boolean>(false);

export const getOrderRequestSchemaSubject = (): BehaviorSubject<OrderRequestSchema[]> => orderRequestSchemasSubject;
export const getOrderRequestSchemaLoadingSubject = (): BehaviorSubject<boolean> => orderRequestSchemasLoadingSubject;

export interface UseOrderRequestSchemasStoreReturn {
  fetchOrderRequestSchemas: () => Promise<void>;
  clear: () => void;
  setOrderRequestSchemas: (orderRequestSchemas: OrderRequestSchema[]) => void;
}

export const useOrderRequestSchemasStore = (): UseOrderRequestSchemasStoreReturn => {
  const fetchOrderRequestSchemas = async (): Promise<void> => {
    orderRequestSchemasLoadingSubject.next(true);

    const { data, error } = await fetchOrderRequestSchemasApi();

    if (data) orderRequestSchemasSubject.next(data);
    if (error) addError('general', error.message);

    orderRequestSchemasLoadingSubject.next(false);
  };

  const setOrderRequestSchemas = (orderRequestSchemas: OrderRequestSchema[]) =>
    orderRequestSchemasSubject.next(orderRequestSchemas);

  const clear = () => orderRequestSchemasSubject.next([]);

  return {
    fetchOrderRequestSchemas,
    clear,
    setOrderRequestSchemas
  };
};
